export default "__VITE_ASSET__BBU0VYwA__"